import { createPortal } from 'react-dom';
import { Box } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { useDisclosure } from '@hooks/useDisclosure';
import { RemarkButton } from '@Components/IconButton';
import Remark from '@Components/Remark';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import {
  IGreenhouseGoalTermFormValues,
  INetZeroFormValues,
} from '../../EsgGreenhouseFormProvider/types';

export const NET_ZERO_REMARK_ID = 'net-zero-remark';

const NetZeroRemark = () => {
  const { control, getValues } = useGreenhouseForm();

  const { remark } =
    getValues('greenhouseGoalTerm.netZero') ?? ({} as INetZeroFormValues);
  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const remarkEl = document.getElementById(NET_ZERO_REMARK_ID);

  const { completedSection } =
    useWatch({ name: 'greenhouseGoalTerm', control }) ??
    ({} as IGreenhouseGoalTermFormValues);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        remarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              topic="การตั้งเป้าหมายการปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์ (Net-Zero Greenhouse Gas Emissions)"
              fieldPath="greenhouseGoalTerm.netZero.remark"
              setOpen={open}
              onDelete={close}
              isCompletedTh={isCompletedTh}
              isCompletedEn={isCompletedEn}
            />
          </Box>,
          remarkEl
        )}
    </>
  );
};

export default NetZeroRemark;
